/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_RestoreInputs */

const cs_documents_restore = /** @type {(inputs: Documents_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit`)
};

const en_documents_restore = /** @type {(inputs: Documents_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Documents_RestoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_restore = /** @type {((inputs?: Documents_RestoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_RestoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_restore(inputs)
	return cs_documents_restore(inputs)
});